<template>
    <div>
    	<header class="mui-bar mui-bar-nav">
			<a class="mui-icon mui-icon-left-nav mui-pull-left" @click="$router.back(-1)"></a>
			<h1 class="mui-title">筛选</h1>
			<button class="mui-btn mui-btn-link mui-pull-right" @click="filterSure()">确定</button>
		</header>
		<div class="mui-content">
			<p class="title fColor">选择操作类型</p>
			<div class="myflex">
		        <div class="flexBox initBtn active"  @click="facadeSelect($event,'3')" >扣费</div> <!--0开户1充值2退户-->
		        <div class="flexBox initBtn" @click="facadeSelect($event,'0')">开户</div>
		        <div class="flexBox initBtn" @click="facadeSelect($event,'1')" >充值</div>
		        <div class="flexBox initBtn" @click="facadeSelect($event,'2')">退户</div>  
		    </div>
		    <p class="title fColor">能耗类型</p>
			<div class="myflex">
		        <div class="flexBox energyBtn active" @click="energyClick" energyId="">全部</div>
		        <div :class=energyClass(energy)  @click="energyClick" v-for="(energy,index) in energys" :key="index" :energyId='energyId(energy)'>{{energy.energy_type_name}}</div>
		    </div>
		    <p class="title fColor">时间段</p>
		    <div class="timeSelect">
		    	<span data-options='{"type":"date"}' class="fl time" id="startTime"></span>至
		    	<span data-options='{"type":"date"}' class="fr time" id="endTime"></span>
		    </div>
		</div>	
    </div>
</template>

<script>
	import { GetFacadeEnergyType } from '@/request/api';
	var picker;
    export default{
    	data: function(){
			return {
				operation:'',
				energyInfomation:{
					"energyid":'',
					"energyname":'全部'
				},
				energys: []
			}
		},
		mounted() {
			var _this = this;
			
			//初始化赋值。
			var filterInfo = JSON.parse(sessionStorage.getItem("filterInfo"));
			if(filterInfo){
				var operation = filterInfo.operation;
				$(".initBtn").removeClass("active");
				if(operation){
					this.operation = operation;
					$(".initBtn:eq("+(parseInt(operation)+1)+")").addClass("active");
				}else{
					$(".initBtn:eq(0)").addClass("active");
				}
				$("#startTime").html(filterInfo.startTime);
				$("#endTime").html(filterInfo.endTime);
				
				var myEnergy = filterInfo.energy;
				if(!myEnergy.energyid){
					//表示选择的是全部。
					//获取当前的能耗类型。
    				this.getEnergy();
				}else{
					$(".energyBtn:eq(0)").removeClass("active");
					//表示当前选择了能耗类型。
					this.getEnergy(myEnergy.energyid);
				}
			}else{
				this.getEnergy();
			}
    		
			mui.init();
			var btns = mui('.time');
			btns.each(function(i, btn) {
				btn.addEventListener('tap', function() {
					var _this = this;
					var optionsJson = this.getAttribute('data-options') || '{}';
					var options = JSON.parse(optionsJson);
					var id = this.getAttribute('id');
					if($(".mui-dtpicker").length ==0){
						picker = new mui.DtPicker(options);
					}
					picker.show(function(rs) {
						_this.innerHTML = rs.text;
						picker.dispose();
					});
				}, false);
			});
		},
		methods:{
			energyId(energy){
				return energy.energy_type_id
			},
			energyClass(energy){
				if(energy.selected){
					return "flexBox energyBtn active";
				}else{
					return "flexBox energyBtn"
				}
			},
			facadeSelect(e,index){
				var myElem = $(e.target);
				var myElem = $(e.target);
				myElem.addClass("active");
				myElem.siblings().removeClass("active");
    			this.operation = index;
			},
			energyClick(e){
				//绑定点击事件
				var myElem = $(e.target);
				myElem.addClass("active");
				myElem.siblings().removeClass("active");
				var energyid = myElem.attr("energyid");
				var energyname = myElem.text()
				this.energyInfomation = {
					energyid:energyid,
					energyname:energyname
				};
			},
			getEnergy(energyid){
				var facade = JSON.parse(sessionStorage.getItem("facade"));
				GetFacadeEnergyType({     
			    	"facade_id":facade.id,
			   	}).then(res => {
			    	// 获取数据成功后的其他操作
			    	if(res.result =='true'){
			    		//循环一遍，判断当前选择的能耗类型的id。
			    		if(energyid){
			    			var myIndex='';
			    			var energyname = ''
			    			$.each(res.data, function(index,vals) {
			    				if(vals.energy_type_id == energyid){
			    					myIndex = index;
			    					energyname = vals.energy_type_name
			    				}
			    			});
			    			if(myIndex+''){
			    				res.data[myIndex].selected = true;
			    				this.energys = res.data;
				    			this.energyInfomation = {
				    				energyid:energyid,
									energyname:energyname
				    			}
			    			}else{
			    				$(".initBtn:eq(0)").addClass("active");
			    				this.energyInfomation = {
				    				energyid:'',
									energyname:'全部'
				    			}
			    			}
			    		}else{
			    			this.energys = res.data;
			    		}
			    	}
			    	else{
			    		mui.toast(res.description,{ duration:'long'});	
			    	}
		  		}) 
			},
			filterSure(){
				//绑定点击事件，确定当前筛选条件。
				var startTime = $("#startTime").html();
				var endTime = $("#endTime").html();
				var combineJson = {
					startTime:startTime,
					endTime:endTime,
					operation:this.operation,
					energy:this.energyInfomation
				}
				sessionStorage.setItem("filterInfo",JSON.stringify(combineJson));
				//跳转到more界面。
				this.$router.push({path: '/more'});
			}
		}
	}
</script>
<style>
     @import '../common/css/public.css';
</style>


// WEBPACK FOOTER //
// src/pages/filter.vue